export function generateManifest(pickedLang) {
  var manifest = {
    "name": pickedLang.name,
    "short_name": pickedLang.name,
    "icons": [
      {
        "src": `${document.location.origin}/static/img/icons/${pickedLang.path}/36.png`,
        "sizes": "36x36",
        "type": "image/png"
      },
      {
        "src": `${document.location.origin}/static/img/icons/${pickedLang.path}/48.png`,
        "sizes": "48x48",
        "type": "image/png"
      },
      {
        "src": `${document.location.origin}/static/img/icons/${pickedLang.path}/57.png`,
        "sizes": "57x57",
        "type": "image/png"
      },
      {
        "src": `${document.location.origin}/static/img/icons/${pickedLang.path}/60.png`,
        "sizes": "60x60",
        "type": "image/png"
      },
      {
        "src": `${document.location.origin}/static/img/icons/${pickedLang.path}/72.png`,
        "sizes": "72x72",
        "type": "image/png"
      },
      {
        "src": `${document.location.origin}/static/img/icons/${pickedLang.path}/76.png`,
        "sizes": "76x76",
        "type": "image/png"
      },
      {
        "src": `${document.location.origin}/static/img/icons/${pickedLang.path}/96.png`,
        "sizes": "96x96",
        "type": "image/png"
      },
      {
        "src": `${document.location.origin}/static/img/icons/${pickedLang.path}/120.png`,
        "sizes": "120x120",
        "type": "image/png"
      },
      {
        "src": `${document.location.origin}/static/img/icons/${pickedLang.path}/144.png`,
        "sizes": "144x144",
        "type": "image/png"
      },
      {
        "src": `${document.location.origin}/static/img/icons/${pickedLang.path}/152.png`,
        "sizes": "152x152",
        "type": "image/png"
      },
      {
        "src": `${document.location.origin}/static/img/icons/${pickedLang.path}/180.png`,
        "sizes": "180x180",
        "type": "image/png"
      },
      {
        "src": `${document.location.origin}/static/img/icons/${pickedLang.path}/192.png`,
        "sizes": "192x192",
        "type": "image/png"
      },
      {
        "src": `${document.location.origin}/static/img/icons/${pickedLang.path}/512.png`,
        "sizes": "512x512",
        "type": "image/png"
      }
    ],
    "scope": `${document.location.origin}/`,
    "start_url": `${document.location.origin}/${pickedLang.path}`,
    "display": "standalone",
    "background_color": "#ffffff",
    "theme_color": "#ffffff"
  }



  const stringManifest = JSON.stringify(manifest);
  const blob = new Blob([stringManifest], {type: 'application/json'});
  const manifestURL = URL.createObjectURL(blob);
  document.querySelector('#manifest').setAttribute('href', manifestURL);

  var link = document.createElement('Link');
  link.rel = "manifest";
  link.setAttribute('href', 'data:application/json;charset=8' + stringManifest)
}


// WEBPACK FOOTER //
// ./src/locales/manifest.js